import { ProductCarouselItem } from 'components/shared/ProductCarousel';
import { AirRingColors } from '.';
import { DesktopCarouselBanner } from 'components/ring-air/DesktopCarouselBanner';

export const RingAirCarouselData: Partial<
  Record<AirRingColors, readonly ProductCarouselItem[]>
> = {
  [AirRingColors.ASTER_BLACK]: [
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/aster-black/1.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/aster-black/1.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/aster-black/1.png',
      objectPositionBottom: false,
      alt: '',
      title: <DesktopCarouselBanner />,
      textPosition: 'top-center' as const,
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/aster-black/2.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/aster-black/2.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/aster-black/2.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/aster-black/3.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/aster-black/3.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/aster-black/3.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/aster-black/4.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/aster-black/4.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/aster-black/4.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/aster-black/5.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/aster-black/5.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/aster-black/5.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/aster-black/6.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/aster-black/6.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/aster-black/6.png',
      objectPositionBottom: false,
      alt: '',
    },
  ],
  [AirRingColors.BIONIC_GOLD]: [
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/bionic-gold/1.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/1-1.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/1.png',
      objectPositionBottom: false,
      alt: '',
      title: <DesktopCarouselBanner />,
      textPosition: 'top-center' as const,
    },
    // { // TODO: change this image to the new one
    //   src: 'web_v2/ring-buy/carousel-assets-new/full/bionic-gold/2-v2.png',
    //   srcResponsive:
    //     'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/2-v2.png',
    //   thumb: 'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/2.png',
    //   objectPositionBottom: false,
    //   alt: '',
    // },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/bionic-gold/3.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/3.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/3.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/bionic-gold/4.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/4.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/4.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/bionic-gold/5.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/5.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/5.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/bionic-gold/6.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/6.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/bionic-gold/6.png',
      objectPositionBottom: false,
      alt: '',
    },
  ],
  [AirRingColors.MATTE_GREY]: [
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/matte-grey/1.png',
      srcResponsive: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/1.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/1.png',
      objectPositionBottom: false,
      alt: '',
      title: <DesktopCarouselBanner />,
      textPosition: 'top-center' as const,
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/matte-grey/2-v2.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/matte-grey/2-v2.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/2.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/matte-grey/3.png',
      srcResponsive: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/3.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/3.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/matte-grey/4.png',
      srcResponsive: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/4.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/4.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/matte-grey/5.png',
      srcResponsive: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/5.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/5.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/matte-grey/6.png',
      srcResponsive: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/6.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/matte-grey/6.png',
      objectPositionBottom: false,
      alt: '',
    },
  ],
  [AirRingColors.SPACE_SILVER]: [
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/space-silver/1.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/space-silver/1.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/space-silver/1.png',
      objectPositionBottom: false,
      alt: '',
      title: <DesktopCarouselBanner />,
      textPosition: 'top-center' as const,
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/space-silver/2.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/space-silver/2.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/space-silver/2.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/space-silver/3.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/space-silver/3.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/space-silver/3.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/space-silver/4.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/space-silver/4.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/space-silver/4.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/space-silver/5.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/space-silver/5.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/space-silver/5.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/space-silver/6.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/space-silver/6.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/space-silver/6.png',
      objectPositionBottom: false,
      alt: '',
    },
  ],
  [AirRingColors.RAW_TITANIUM]: [
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/raw-titanium/1.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/1.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/1.png',
      objectPositionBottom: false,
      alt: '',
      title: <DesktopCarouselBanner />,
      textPosition: 'top-center' as const,
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/raw-titanium/2.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/2.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/2.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/raw-titanium/3.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/3.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/3.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/raw-titanium/4.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/4.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/4.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/raw-titanium/5.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/5.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/5.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/raw-titanium/6.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/6.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/raw-titanium/6.png',
      objectPositionBottom: false,
      alt: '',
    },
  ],
  [AirRingColors.ROSE_GOLD]: [
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/brushed-rose-gold/1.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/1.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/1.png',
      objectPositionBottom: false,
      alt: '',
      title: <DesktopCarouselBanner />,
      textPosition: 'top-center' as const,
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/brushed-rose-gold/2.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/2.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/2.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/brushed-rose-gold/3-v2.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/3-v2.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/3.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/brushed-rose-gold/4.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/4.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/4.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/brushed-rose-gold/5.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/5.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/5.png',
      objectPositionBottom: false,
      alt: '',
    },
    {
      src: 'web_v2/ring-buy/carousel-assets-new/full/brushed-rose-gold/6.png',
      srcResponsive:
        'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/6.png',
      thumb: 'web_v2/ring-buy/carousel-assets-new/min/brushed-rose-gold/6.png',
      objectPositionBottom: false,
      alt: '',
    },
  ],
};
